<template>
  <div>
    <div
      class="
        w-100
        p-2
        d-flex
        align-items-center
        wc-stage__header
        wc-stage__header-active
      "
    >
      <h2 class="d-inline-block mb-0 font-weight-bold">
        {{ $t('checkout') }}
      </h2>
    </div>
    <div class="m-3">
      <div class="wc-select-payment-type">{{ $t('selectPaymentType') }}</div>
      <div class="wc-payment-type-button mt-5">
        <button
          @click="$router.push('/scan/co/cr')"
          class="btn btn-primary btn-block w-25 stage-button mt-3 m-auto w-100"
        >
          {{ $t('completeAtCashRegister') }}
        </button>
        <button
          v-if="!prohibitedItemsInCart"
          @click="$router.push('/scan/co/pp')"
          class="btn btn-primary btn-block w-25 stage-button mt-3 m-auto w-100"
        >
          {{ $t('payOnYourPhone') }}
        </button>
        <button
          :aria-label="$t('goBack')"
          @click="$router.go(-1)"
          class="btn unstyled-btn text-primary font-weight-bold mt-3 m-auto w-100"
        >
          {{ $t('goBack') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WCCheckoutPaymentType',
  props: {
    prohibitedItemsInCart: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.wc-stage__header-active {
  background-color: var(--secondary-lighter-7, get-color('secondary', 'lighter-7'));
}
.wc-select-payment-type {
  width: 80%;
}
.wc-payment-type-button {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-left: 2rem;
  margin-right: 2rem;
}
</style>
